import PropTypes from "prop-types";

import getFormattedDate from "@/view/utils/getFormattedDate";
import {
  dateCss,
  headingCss,
  questionTextCss,
  studentResponseAreaCss,
  teacherResponseAreaCss,
} from "./WritePromptSubmitted.style";

const propTypes = {
  classroomName: PropTypes.name,
  currentWritePrompt: PropTypes.object,
  writePromptResponses: PropTypes.arrayOf(PropTypes.object),
  writePromptSubmittedClassroomNameRef: PropTypes.object,
};

const WritePromptSubmitted = ({
  classroomName,
  currentWritePrompt,
  writePromptResponses,
  writePromptSubmittedClassroomNameRef,
}) => {
  /**
   * The write responses (writePromptResponses) are already sorted in ascending date_completed order
   */
  const renderStudentResponse = (response) => {
    return (
      <>
        <h3 css={headingCss}>Submitted response</h3>
        <p css={dateCss}>
          Submitted: {getFormattedDate(new Date(response.date_completed))}
        </p>
        <div css={studentResponseAreaCss}>
          <p>{response.text}</p>
        </div>
      </>
    );
  };

  const renderResponseGrade = (score) => {
    return <h3 css={headingCss}>Your score {score}/4</h3>;
  };

  const renderTeacherResponse = (response) => {
    const { teacher, text, date_shared: dateShared } = response.review;
    const { user } = teacher;
    const teacherName = user.first_name + " " + user.last_name;

    return (
      <>
        <h3 css={headingCss}>{`${teacherName}'s`} response</h3>
        <p css={dateCss}>Submitted: {getFormattedDate(new Date(dateShared))}</p>
        <div css={teacherResponseAreaCss}>
          <p>{text}</p>
        </div>
      </>
    );
  };

  const questionText =
    (currentWritePrompt?.questions[0].html_question ||
      currentWritePrompt?.questions[0].question) ??
    "";

  return (
    <>
      <h3
        tabIndex={0}
        ref={writePromptSubmittedClassroomNameRef}
        css={headingCss}
      >
        {classroomName}
      </h3>
      <p
        css={questionTextCss}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: questionText }}
      />
      {writePromptResponses.map((response) => {
        return (
          <div key={`response-item-${response.id}`}>
            {renderStudentResponse(response)}
            {response?.review?.score &&
              renderResponseGrade(response?.review?.score)}
            {response?.review?.text && renderTeacherResponse(response)}
          </div>
        );
      })}
    </>
  );
};

WritePromptSubmitted.propTypes = propTypes;

export default WritePromptSubmitted;
